import { Button, ButtonGroup, Card, Link, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import Loading from "../components/Loading";
import { useGetOrderLineitemsQuery, useGetOrderQuery, useGetOrderShipping_labelsQuery, useGetOrderTracking_infoQuery, useUpdateOrderMutation } from "../features/model/orderSlice";
import { lineitemFields, orderFields, shippinglabelFields } from "../features/model/modelFields";
import { capitalized } from "../helpers/strings";
import { useParams, Link as RouterLink } from "react-router-dom";
import { useDeleteShippingLabelMutation, useUpdateShippingLabelMutation } from "../features/model/shippinglabelSlice";
import { useDeleteTrackingInfoMutation, useUpdateTrackingInfoMutation } from "../features/model/trackinginfoSlice";
import { useState } from "react";
import { LineItemHeaders, LineItemRow } from "../components/LineItemRow";
import { OrderCard } from "../components/OrderCard";
import { OrderActionsList } from "../components/ActionsList";
import { ShippingLabelCard } from "../components/ShippingLabelCard";
import { TrackingInfoCard } from "../components/TrackingInfoCard";
import { OrderEditCard } from "../components/OrderEditCard";
import { useSelector } from "react-redux";

const OrderEditView = () => {
    const user = useSelector(state => state.auth.user)
    let params = useParams();
    const {data: object, error, isLoading } = useGetOrderQuery(params.orderId)
    const [showActions, setShowActions] = useState(false);

    const {data: items, error: itemsError, isLoading: isLoadingItems } = useGetOrderLineitemsQuery(params.orderId)
    const {data: shipments, error: shipmentsError, isLoading: isLoadingShipments } = useGetOrderShipping_labelsQuery(params.orderId)
    const {data: tracking, error: trackingError, isLoading: isLoadingTracking } = useGetOrderTracking_infoQuery(params.orderId)

    if(!user.permissions.includes("admin")) {
        return <div>Error: No edit permissions.</div>
    }

    if ( isLoading || isLoadingItems || isLoadingShipments || isLoadingTracking) {
      return <Loading />;
    }
    if ( error || itemsError || shipmentsError || trackingError ) {
        return <div>{`${error}`}</div>
    }
    
    return <Stack sx={{margin: 2}} spacing={2}>
        <ButtonGroup>
            <Button component={RouterLink} to={`/orders/`}>Back</Button>
            <Button variant="outlined" component={RouterLink} to={`/orders/${params.orderId}`}>View</Button>
        </ButtonGroup>

        <Paper>
            <OrderEditCard order={object} />
        </Paper>
            <TableContainer component={Paper}>
                <Stack direction="row" sx={{margin: 2}}>
                    <Typography variant="h2" sx={{marginTop: 1}}>Line Items</Typography>
                    <Button sx={{marginLeft: 4}} variant={showActions ? "contained" : "outlined"} onClick={() => {
                        setShowActions(!showActions);
                    }}>history</Button>
                </Stack>
            <Table>
                <LineItemHeaders />
                <TableBody>
                    {
                        items.objects.map((item, i) => <LineItemRow object={item} key={item.id} showActions={showActions} />)
                    }
                </TableBody>
            </Table>
            </TableContainer>
        <Paper>
            <Card>
                <Typography variant="h2" sx={{margin: 2}}>Shipping labels</Typography>
                <Stack sx={{margin: 2}} spacing={2} direction={"column"}>
                {
                    shipments.objects.map((shipment, i) => {
                        return <ShippingLabelCard object={shipment} key={shipment.id} />
                    })
                }
                </Stack>
            </Card>
        </Paper>
        <Paper>
            <Card>
                <Typography variant="h2" sx={{margin: 2}}>Tracking info</Typography>
                <Stack sx={{margin: 2}} spacing={2} direction={"column"}>
                {
                    tracking.objects.map((tracking, i) => {
                        return <TrackingInfoCard object={tracking} key={tracking.id} />
                    })
                }
                </Stack>
            </Card>
        </Paper>
        <Paper>
            <Card>
                <Typography variant="h2" sx={{margin: 2}}>Order history</Typography>
                <OrderActionsList order={object} />
            </Card>
        </Paper>
    </Stack>;

}

export { OrderEditView };